import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useAIAgentChatImpl from '../hooks/useAIAgentChat';
import {
  DEFAULT_AGENT_MODULE_ID,
  resolveAgentModuleFromPath,
} from '../config/modules';

const AIAgentContext = createContext(null);

export function AIAgentProvider({ children }) {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [activeModuleId, setActiveModuleId] = useState(() => {
    const resolved = resolveAgentModuleFromPath(location.pathname);
    return resolved !== DEFAULT_AGENT_MODULE_ID ? resolved : 'facturation';
  });

  const chat = useAIAgentChatImpl({ activeModuleId, setActiveModuleId });

  const openAgent = useCallback(() => setIsOpen(true), []);
  const closeAgent = useCallback(() => setIsOpen(false), []);
  const toggleAgent = useCallback(() => setIsOpen((prev) => !prev), []);

  const value = useMemo(
    () => ({
      isOpen,
      openAgent,
      closeAgent,
      toggleAgent,
      activeModuleId,
      setActiveModuleId,
      chat,
    }),
    [isOpen, openAgent, closeAgent, toggleAgent, activeModuleId, chat],
  );

  return (
    <AIAgentContext.Provider value={value}>{children}</AIAgentContext.Provider>
  );
}

export function useAIAgent() {
  const ctx = useContext(AIAgentContext);
  if (!ctx) {
    throw new Error('useAIAgent must be used within AIAgentProvider');
  }
  return ctx;
}

export function useAIAgentChat() {
  return useAIAgent().chat;
}
